import axios from "axios";
import { BASE_URL } from "../_constants/urlConstants";

const testService = () => async () => {
  const apiEndpoint = BASE_URL + "/api/Pdf/TestService";
  try {
    const res = await axios.get(apiEndpoint);
    return res.status === 200 ? true : false;
  } catch (e) {
    return false;
  }
};

const pdfActions = {
  testService,
};

export default pdfActions;
